import { render } from "./InputGuidelines.vue?vue&type=template&id=d77976ba"
import script from "./InputGuidelines.vue?vue&type=script&lang=js"
export * from "./InputGuidelines.vue?vue&type=script&lang=js"

import "./InputGuidelines.vue?vue&type=style&index=0&id=d77976ba&lang=css"

import exportComponent from "/builds/cu2207/business/produkter.dk/pfp-public-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__